var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-avatar-link',{attrs:{"href":_vm.serviceAccount.webPath,"title":_vm.serviceAccount.name}},[_c('gl-avatar-labeled',{attrs:{"size":32,"src":_vm.serviceAccount.avatarUrl,"label":_vm.serviceAccount.name,"sub-label":`@${_vm.serviceAccount.username}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }